"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.readEncodedFile = void 0;

var jschardet_1 = __importDefault(require("jschardet"));

var iconv_lite_1 = require("iconv-lite");

exports.readEncodedFile = function (file, charset) {
  return new Promise(function (res, rej) {
    var reader = new FileReader();
    reader.addEventListener('load', function () {
      if (reader.result === null) {
        rej('Result is null.');
      }

      var result = reader.result;

      if (result.length === 0) {
        return res('');
      }

      if (!charset) {
        var detectedCharset = jschardet_1["default"].detect(result);
        charset = detectedCharset ? detectedCharset.encoding : 'utf-8';
      }

      var decoded = iconv_lite_1.decode(Buffer.from(result, 'binary'), charset);
      return res(decoded);
    });
    reader.readAsBinaryString(file);
  });
};